import { render } from "./PartnerManagement.vue?vue&type=template&id=06544f5d&scoped=true"
import script from "./PartnerManagement.vue?vue&type=script&lang=js"
export * from "./PartnerManagement.vue?vue&type=script&lang=js"

import "./PartnerManagement.vue?vue&type=style&index=0&id=06544f5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06544f5d"],['__file',"src/views/PartnerManagement/PartnerManagement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06544f5d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06544f5d', __exports__)) {
    api.reload('06544f5d', __exports__)
  }
  
  module.hot.accept("./PartnerManagement.vue?vue&type=template&id=06544f5d&scoped=true", () => {
    api.rerender('06544f5d', render)
  })

}


export default __exports__